import { Controller } from "@hotwired/stimulus"
import { lockBody, unlockBody } from "./body_lock.js"

export default class extends Controller {
  connect() {
    this.isOpen = false
    this.boundHandleKeydown = this.handleKeydown.bind(this)

    this.toggleElement = document.getElementById("nav-toggle")
    this.panelElement = document.getElementById("nav-panel")
    this.overlayElement = document.getElementById("nav-overlay")
    this.closeElement = document.getElementById("nav-close")

    if (!this.toggleElement || !this.panelElement || !this.overlayElement) return

    this.toggleElement.addEventListener("click", this.open)
    this.closeElement?.addEventListener("click", this.close)
    this.overlayElement.addEventListener("click", this.close)
    document.addEventListener("keydown", this.boundHandleKeydown)
  }

  disconnect() {
    this.toggleElement?.removeEventListener("click", this.open)
    this.closeElement?.removeEventListener("click", this.close)
    this.overlayElement?.removeEventListener("click", this.close)
    document.removeEventListener("keydown", this.boundHandleKeydown)
  }

  open = () => {
    if (this.isOpen) return
    this.setOpen(true)
  }

  close = () => {
    if (!this.isOpen) return
    this.setOpen(false)
  }

  handleKeydown(event) {
    if (event.key === "Escape" && this.isOpen) this.close()
  }

  setOpen(isOpen) {
    this.isOpen = isOpen
    this.panelElement.style.transform = isOpen ? "translateX(0)" : "translateX(-100%)"
    isOpen ? lockBody() : unlockBody()
    this.overlayElement.classList.toggle("opacity-0", !isOpen)
    this.overlayElement.classList.toggle("pointer-events-none", !isOpen)
  }
}
